import { FormLayout, InputField, ImageField } from '@app/lib/form'
import { Component } from '@contember/interface'
import { LocaleSideDimension } from '../locale-side-dimension'
import { RichText } from '../rich-text'
import { BlockEditorField } from '@app/lib/plugins/rich-text/editor'
import { SelectLinkField } from '@app/lib/plugins/link/select-link-field'

export const ConfigurationForm = Component(() => (
	<FormLayout>
		<ImageField
			label="Gradient Icon"
			baseField="icon"
			urlField="url"
			widthField="width"
			heightField="height"
			fileNameField="meta.fileName"
			fileTypeField="meta.fileType"
			fileSizeField="meta.fileSize"
			lastModifiedField="meta.lastModified"
		/>
		<LocaleSideDimension>
			<InputField field="title" label="Title" required />
			<RichText field="description" label="Lead text" />
			<BlockEditorField field="content.data" referencesField="content.references" label="Content" />
			<InputField field="price" label="Price" required />
			<InputField
				field="priceValue"
				label="Price value (structured data)"
				description="Numeric price for schema.org markup. Fill only when the price shown on the page is a concrete amount."
				inputProps={{ type: 'number', step: '0.01' }}
			/>
			<InputField
				field="priceCurrency"
				label="Price currency (structured data)"
				description="ISO 4217 code, e.g. CZK, EUR, HUF"
				inputProps={{ placeholder: 'CZK' }}
			/>
			<InputField field="buttonLabel" label="Button title" />
			<SelectLinkField field="link" label="Link" />
		</LocaleSideDimension>
	</FormLayout>
))
